import { api } from '../connection/api'

export async function getUseAndPrivacyTerms() {
    return await api.get(`associate/use_privacy_terms`);
}